import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  dateFormat,
  dateFormatYear,
  showDateFormatYear,
  subtractAndFormatDate,
} from "../../utility/utils";
import Dropdown from "react-bootstrap/Dropdown";
import ModalBox from "../../common/ModalBox";
import { toast } from "react-toastify";
import useDebounce from "../../hooks/useDebounce";
import DatePicker, { setDefaultLocale } from "react-datepicker";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import Pagination from "react-js-pagination";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { red } from "@mui/material/colors";
import useButtonLoader from "../../hooks/useButtonLoader";
import { actionsChecker, permissionChecker } from "../../config/roleAccess";
import { usePermission } from "../../context/create_Context";
import {
  deleteSellerController,
  sellerListController,
  getSellersProductController,
  sellerStatusChangeController,
  createSellerProductRelation,
  deleteSellerProductRelationController,
} from "../../services/sellerServices/sellerServices";
import { productListController } from "../../services/productServices/productListingController";
const ProductRelation = () => {
  const [sellerId, setSellerId] = useState("");
  const [productId, setProductId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [submitButton, setSubmitButton] = useButtonLoader();
  const [deleteReason, setDeleteReason] = useState("");
  const [errors, setErrors] = useState({
    seller: "",
    product: "",
  });
  const [search, setSearch] = useState("");
  const [filterByDate, setFilterByDate] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [startNumber, setStartNumber] = useState(1);
  const [totalList, setTotalList] = useState();
  const [modalStatus, setModalStatus] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [sellers, setSellers] = useState([]);
  const [sellerProducts, setSellerProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const debounceValue = useDebounce(search, 500);
  const [loader, show, hide] = useFullPageLoader();
  const [sellerSearchTerm, setSellerSearchTerm] = useState("");
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const { permission } = usePermission();
    const navigate = useNavigate();
  

  // Filtered lists
  const filteredSellers = sellers.filter((seller) =>
    seller.sellerName.toLowerCase().includes(sellerSearchTerm.toLowerCase())
  );

  const filteredProducts = products.filter((product) =>
    product.productName.toLowerCase().includes(productSearchTerm.toLowerCase())
  );

  const fetchingSellerProductList = async () => {
    try {
      show();
      const response = await getSellersProductController(
        activePage,
        debounceValue ? debounceValue : "",
        filterByDate ? dateFormatYear(filterByDate) : "",
        limit
      );
      //console.log(response);
      if (response.code === 200) {
        hide();
        setSellerProducts(response?.data?.rows);
        setTotalList(response?.data?.count);
      } else {
        toast.error(response.message);
        hide();
      }
    } catch (e) {
      console.log(e.message);
      hide();
    }
  };
  //Fetching Seller List
  const fetchingSellerManagementList = async () => {
    try {
      show();
      const response = await sellerListController(1, null, "", "", 100000);
      if (response.code === 200) {
        hide();
        setSellers(response?.data?.rows);
      } else {
        toast.error(response.message);
        hide();
      }
    } catch (e) {
      console.log(e.message);
      hide();
    }
  };
  //Fetching Product List
  const fetchingProductList = async () => {
    try {
      const response = await productListController(1, 100000);

      if (response?.code === 200) {
        const filteredProductList = response?.data?.rows.filter(
          ({ noOfStock }) => noOfStock !== 0
        );
        setProducts(filteredProductList);
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
      }
    } catch (error) {
      toast.error("Error fetching product list");
    } finally {
      setSubmitButton(false);
    }
  };

  useEffect(() => {
    fetchingSellerManagementList();
    fetchingProductList();
  }, [modalStatus]);

  useEffect(() => {
    fetchingSellerProductList();
  }, [debounceValue, , activePage, filterByDate, limit]);

  // Delete Input Field Validation
  const validation = () => {
    let validationStatus = true;
    let newErrors = {
      seller: "",
      product: "",
    };

    if (!selectedSeller) {
      newErrors.seller = "Seller is Mandatory *";
      validationStatus = false;
    }

    if (!selectedProduct) {
      newErrors.product = "Product is Mandatory *";
      validationStatus = false;
    }

    setErrors(newErrors);
    return validationStatus;
  };

  // Fetching Delete Seller
  const deleteSellerHandler = async (e) => {
    e.preventDefault();
    if (!deleteReason) {
      setErrors(() => ({
        deleteReason: "Unlink reason is mandatory *",
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        deleteReason: "",
      }));
    }
      try {
        const data = {
          sellerId,
          productId,
        };

        const response = await deleteSellerProductRelationController(data);
        if (response?.data?.code === 200) {
          setDeleteModal(false);
          setDeleteReason("");
          toast.success(response.data?.message);
          fetchingSellerProductList();
          setSubmitButton(false);
        } else {
          toast.error(
            response?.response?.data?.message || response?.data?.message
          );
          setDeleteModal(false);
          setErrors("");
          setDeleteReason("");
          setSubmitButton(false);
        }
      } catch (e) {
        //  console.log(e.message);
        setSubmitButton(false);
        setDeleteReason("");
      }
    
  };

  const handleProceed = async (e) => {
    e.preventDefault();
    const isValid = validation();
     if (!isValid) return;

    try {
      setSubmitButton(true);
      const result = await createSellerProductRelation(sellerId, productId);

      if (result?.code === 200) {
        toast.success("Seller-Product relation created successfully!");
        setModalStatus(false);
        setSelectedSeller("");
        setSelectedProduct("");
        setErrors({
          seller: "",
          product: "",
        });
        fetchingSellerProductList();
      } else {
        toast.error(
          result?.message || "Failed to create seller-product relation"
        );
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setSubmitButton(false);
    }
  };
  //*Handle Pagination*
  const handlePageChange = (event) => {
    setActivePage(event);
  };

  useEffect(() => {
    setStartNumber((activePage - 1) * limit + 1);
  }, [activePage]);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <div className="page_title_wrap">
            <h2 className="page-title">
              <span
                className="page-title-icon bg-gradient-primary text-white me-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <i className="mdi mdi-chevron-double-left"></i>
              </span>
              Product Sold By Sellers
            </h2>
              <div className="button_wrap">
                <Link
                  to="#"
                  className="btn btn-outline-success cstm_btn_wrap_theme"
                  onClick={(e) => {
                    e.preventDefault();
                    setModalStatus(true);
                  }}
                >
                  <i className="mdi menu-icon menu-icon"></i>Associate Product
                </Link>
              </div>
            </div>
          </div>

          {/* Search bar  */}
          <div className="row wrap_selectCstm">
            <div className="col-1 cstm_padding_set">
              <select
                className="pageSelect input"
                onChange={(e) => setLimit(e.target.value)}
                value={limit}
              >
                <option value={"10"}>10</option>
                <option value={"25"}>25</option>
                <option value={"50"}>50</option>
                <option value={"100"}>100</option>
              </select>
            </div>
            <div className="col-lg-3 cstm_padding_set">
              <div className="search_box">
                <i className="mdi mdi-magnify"></i>
                <input
                  type="text"
                  className="form-control search cstm_btn_wrap_theme"
                  placeholder="Search by seller name, product name, email or mobile no. "
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 cstm_padding_set">
              <div className="datePicker_wrap cstm_date_picker">
                <DatePicker
                  showIcon
                  placeholderText="Filter By Date"
                  icon={true}
                  className="input date_picker cstm_btn_wrap_theme2 "
                  selected={filterByDate}
                  value={filterByDate}
                  showYearDropdown
                  yearDropdownItemNumber={100}
                  scrollableYearDropdown
                  showMonthDropdown
                  useShortMonthInDropdown
                  maxDate={Date.now()}
                  onChange={(date) => setFilterByDate(date)}
                  dateFormat="dd/MM/yyyy"
                  onChangeRaw={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </div>
          {loader}

          {/* DropDown for approved Status */}

          <div className="row wrap_selectCstm">
            <div className="col-lg-12 grid-margin stretch-card cstm_padding_set">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product Name</th>
                          <th>Seller Name</th>
                          <th>Email</th>
                          <th>Mobile No.</th>
                          <th>Created At</th>
                          {actionsChecker(permission, 2) && <th>Actions</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {sellerProducts && sellerProducts.length > 0 ? (
                          sellerProducts.map(
                            (
                              { SellerDetail, ProductDetail, createdAt },
                              index
                            ) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>
                                      {(activePage - 1) * limit + index + 1}
                                    </td>
                                    <td>
                                      {ProductDetail?.productName || "---"}
                                    </td>
                                    <td>{SellerDetail?.sellerName || "---"}</td>
                                    <td>{SellerDetail?.email|| "---"}</td>
                                    <td>{SellerDetail?.mobileNumber || "---"}</td>
                                    <td>
                                      {createdAt
                                        ? showDateFormatYear(createdAt)
                                        : "---"}
                                    </td>

                                    <td>
                                      {permissionChecker(permission, 2, 4) && (
                                        <Link className="action_button">
                                          <DeleteRoundedIcon
                                            sx={{ color: red[500] }}
                                            onClick={() => {
                                              setSellerId(SellerDetail.id);
                                              setProductId(ProductDetail.id);
                                              setDeleteModal(true);
                                            }}
                                          />
                                        </Link>
                                      )}{" "}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan={6}>
                              <strong>No Data Found</strong>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5>
                        Showing {startNumber} to{" "}
                        {startNumber + sellerProducts?.length - 1} of{" "}
                        {totalList} entries
                      </h5>
                    </div>
                    {totalList > 10 ? (
                      <div className="pagination_wrap">
                        <Pagination
                          activePage={activePage}
                          linkClass="page-link"
                          previousLabel={"previous"}
                          nextLabel={"next"}
                          itemsCountPerPage={limit}
                          totalItemsCount={totalList}
                          pageRangeDisplayed={5}
                          itemClassLast="last_page next"
                          itemClassFirst="first_page prev"
                          activeLinkClass="active"
                          onChange={handlePageChange}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <ModalBox
              status={modalStatus}
              onClose={() => {
                setModalStatus(false);
                setSelectedSeller("");
                setSelectedProduct("");
                setErrors({
                  seller: "",
                  product: "",
                });
                setSellerSearchTerm("");
                setProductSearchTerm("");
              }}
              title="Select Seller & Product"
              customizedFooter={<></>}
            >
              <React.Fragment>
                <div className="card">
                  <div className="card-body">
                    <form className="forms-sample">
                      <div className="form-group">
                        <Dropdown className="w-100">
                          <Dropdown.Toggle
                            id="dropdown-autoclose-outside"
                            className="bg-white text-dark"
                          >
                            {selectedSeller ? selectedSeller : "Select Seller"}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="cstm_styling_drop_set">
                            <input
                              placeholder="Search seller"
                              className="form-control"
                              value={sellerSearchTerm}
                              onChange={(e) =>
                                setSellerSearchTerm(e.target.value)
                              }
                            />
                            {filteredSellers.length > 0 ? (
                              filteredSellers.map((seller) => (
                                <Dropdown.Item
                                  key={seller.id}
                                  onClick={() => {
                                    setSellerId(seller.id);
                                    setSelectedSeller(seller.sellerName);
                                    setSellerSearchTerm("");
                                  }}
                                  className="text-dark"
                                >
                                  {seller.sellerName}
                                </Dropdown.Item>
                              ))
                            ) : (
                              <Dropdown.Item disabled>
                                No sellers found
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                        {errors.seller && (
                          <span style={{ color: "red" }} className="error">
                            {errors.seller}
                          </span>
                        )}
                      </div>

                      <div className="form-group mt-3">
                        <Dropdown className="w-100">
                          <Dropdown.Toggle
                            id="dropdown-autoclose-outside"
                            className="bg-white text-dark"
                          >
                            {selectedProduct
                              ? selectedProduct
                              : "Select Product"}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="cstm_styling_drop_set">
                            <input
                              placeholder="Search product"
                              className="form-control"
                              value={productSearchTerm}
                              onChange={(e) =>
                                setProductSearchTerm(e.target.value)
                              }
                            />
                            {filteredProducts.length > 0 ? (
                              filteredProducts.map((product) => (
                                <Dropdown.Item
                                  key={product.id}
                                  onClick={() => {
                                    setProductId(product.id);
                                    setSelectedProduct(product.productName);
                                    setProductSearchTerm("");
                                  }}
                                  className="text-dark"
                                >
                                  {product.productName}
                                </Dropdown.Item>
                              ))
                            ) : (
                              <Dropdown.Item disabled>
                                No products found
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                        {errors.product && (
                          <span style={{ color: "red" }} className="error">
                            {errors.product}
                          </span>
                        )}
                      </div>

                      <div className="d-flex justify-content-center align-items-center mt-4">
                        <button
                          type="button"
                          className="btn btn-gradient-primary me-2"
                          onClick={handleProceed}
                        >
                          Associate
                        </button>
                        <button
                          className="btn btn-light"
                          onClick={(e) => {
                            setModalStatus(false);
                            e.preventDefault();
                            setSelectedSeller("");
                            setSelectedProduct("");
                            setErrors("");
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </React.Fragment>
            </ModalBox>
            {/* Cancel Reason Modal*/}
            <ModalBox
              status={deleteModal}
              onClose={() => {
                setDeleteModal(false);
                setDeleteReason("");
                setErrors("");
              }}
              title="Un-Associate Product"
              customizedFooter={<></>}
            >
              <React.Fragment>
                <div className="card">
                  <div className="card-body">
                    <form className="forms-sample">
                      <div className="form-group">
                        <label htmlFor="Banner ">
                          Enter Unassociate Reason{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          id="exampleInputName1"
                          cols={4}
                          value={deleteReason}
                          name="cancelReason"
                          placeholder="Enter unassociate reason"
                          onChange={(e) => setDeleteReason(e.target.value)}
                        />
                        <span style={{ color: "red" }} className="error">
                          {errors.deleteReason}
                        </span>
                        <div className="d-flex justify-content-center align-items-center mt-4">
                          <button
                            type="submit"
                            className="btn btn-gradient-primary me-2"
                            onClick={(e) => {
                              deleteSellerHandler(e);
                            }}
                            ref={submitButton}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-light"
                            onClick={(e) => {
                              setDeleteModal(false);
                              e.preventDefault();
                              setDeleteReason("");
                              setErrors("");
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </React.Fragment>
            </ModalBox>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductRelation;
